import React, { useState } from 'react';
import { Tooltip } from 'antd';

import PoBreakdownModal from './PoBreakdownModal.jsx';
import InfoIcon from '../../assets/images/newImages/info-icon-blue.svg';

/*
 * Drop-in "view PO breakdown" trigger for a "Pending on PO" / "WH Inbound" cell on any page (SKU,
 * Products, Database, Catalog, Restock). Renders just the info icon and owns its own modal state, so a
 * cell only needs: {number}{value > 0 && <PoBreakdownIcon .../>}. The modal isn't mounted until the
 * icon is clicked, so there's no cost per row.
 *   params — { sku_id } or { upc } (matches how the page's rows are keyed)
 *   label  — subtitle in the modal (the SKU string or UPC)
 *   type   — 'pending' | 'inbound'
 */
export default function PoBreakdownIcon({ params, label, type = 'inbound', size = 13, style }) {
  const [open, setOpen] = useState(false);
  if (!params || (params.sku_id == null && !params.upc)) return null;
  return (
    <>
      <Tooltip title="View PO breakdown">
        <img
          src={InfoIcon}
          alt="breakdown"
          style={{ width: size, height: size, cursor: 'pointer', marginLeft: 6, verticalAlign: 'middle', ...style }}
          onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        />
      </Tooltip>
      {open && (
        <PoBreakdownModal open onClose={() => setOpen(false)} params={params} label={label} type={type} />
      )}
    </>
  );
}
